import React from 'react';
import { Route } from 'react-router-dom';

import CRMStats from 'features/crm/pages/CRMStats';
import CrmMap from 'features/crm/pages/CrmMap';
import Notifications from 'features/crm/pages/notifications/Notifications';
import NotificationTemplates from 'features/crm/pages/notifications/NotificationTemplates';
import Orders from 'features/crm/pages/orders/Orders';
import Sms from 'features/crm/pages/notifications/Sms';

export const crmRoutes = (
  <Route path='crm'>
    <Route index element={<CRMStats />} />
    <Route path='map' element={<CrmMap />} />

    <Route path='orders' element={<Orders />} />

    <Route path='notifications'>
      <Route index element={<Notifications />} />
      <Route path='templates' element={<NotificationTemplates />} />
      <Route path='sms' element={<Sms />} />
    </Route>
  </Route>
);

export const crmTitles = [
  { path: '/crm/map', title: 'CRM Карта' },
  { path: '/crm/orders', title: 'Заказы' },
  { path: '/crm/notifications/templates', title: 'Шаблоны уведомлений' },
  { path: '/crm/notifications/sms', title: 'SMS Уведомления' },
  { path: '/crm/notifications', title: 'Уведомления CRM' },
  { path: '/crm', title: 'CRM Статистика' },
];
